"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDisposableModal = createDisposableModal;
exports.Modal = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactDisposableDecorator = _interopRequireDefault(require("react-disposable-decorator"));

var _rx = _interopRequireDefault(require("disposable-component/lib/rx6"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// stateless functional components were not working correctly, so I had to make a very thin component to get state/prop changes to propagate correctly to children components
var _Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(_Portal, _React$Component);

  function _Portal() {
    _classCallCheck(this, _Portal);

    return _possibleConstructorReturn(this, _getPrototypeOf(_Portal).apply(this, arguments));
  }

  _createClass(_Portal, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("span", null, this.props.children);
    }
  }]);

  return _Portal;
}(_react["default"].Component);

var _Modal =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(_Modal, _React$Component2);

  function _Modal() {
    _classCallCheck(this, _Modal);

    return _possibleConstructorReturn(this, _getPrototypeOf(_Modal).apply(this, arguments));
  }

  _createClass(_Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // renderPortal() if < React16 for inital render
      if (!_reactDom["default"].createPortal) this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // renderPortal() if < React16 so that state/prop changes are reflected in the DOM
      if (!_reactDom["default"].createPortal) this.renderPortal();
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      if (!this.parentContainer) {
        // we need to keep a reference to the parent DOM node for future times when this function is called
        this.parentContainer = document.createElement("div");
        document.body.appendChild(this.parentContainer);
      }

      this.props.cancelWhenUnmounted(createCancelableModal(_Portal, this.props, this.parentContainer).subscribe(function () {}));
    }
  }, {
    key: "render",
    value: function render() {
      if (!_reactDom["default"].createPortal) return null;

      if (!this.parentContainer) {
        // we need to keep a reference to the parent DOM node for future times when this function is called
        this.parentContainer = document.createElement("div");
        document.body.appendChild(this.parentContainer);
      }

      return _reactDom["default"].createPortal(this.props.children, this.parentContainer);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.parentContainer && document.body.contains(this.parentContainer)) {
        document.body.removeChild(this.parentContainer);
        this.parentContainer = null;
      }
    }
  }]);

  return _Modal;
}(_react["default"].Component);

var Modal = (0, _reactDisposableDecorator["default"])(_Modal);
exports.Modal = Modal;

function createDisposableModal(El) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return (0, _rx["default"])(function (next, complete, error) {
    if (!parent) {
      parent = document.createElement("div");
      document.body.appendChild(parent);
    }

    _reactDom["default"].render(_react["default"].createElement(El, _extends({}, props, {
      onCompleted: complete,
      onNext: next,
      onError: error
    })), parent);
  }, function () {
    _reactDom["default"].unmountComponentAtNode(parent);

    if (parent.parentNode) parent.parentNode.removeChild(parent);
  });
}
//# sourceMappingURL=disposable-modal.js.map